import { css } from '@emotion/react';
import { Fragment } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Button } from '@mui/material';
import TailorLogo from 'logos/tailor';

import ProjectDropdown from './ProjectDropdown';
import UserDropdown from './UserDropdown';

import useAuthStateAsync from 'store/useAuthStateAsync';
import { signInWithRedirect } from 'aws-amplify/auth';
import getProjectId from 'utils/url/getProjectId';

export default function Header() {
  const authStateAsync = useAuthStateAsync();
  const loggedIn = authStateAsync.status === 'SUCCESS' && authStateAsync.data!.authenticated;
  const loggedOut = authStateAsync.status === 'SUCCESS' && !authStateAsync.data!.authenticated;

  const projectId = getProjectId();

  return (
    <header
      css={css`
        min-height: 65px;
        padding: 8px 50px;

        display: flex;
        align-items: center;
        justify-content: center; /* Center vertically when it wraps */
        flex-wrap: wrap;

        background-color: var(--indigo);
        color: #fff;

        .logo {
          width: 72px;
          display: block;
        }

        nav {
          margin: 0 48px;
          flex-grow: 1;
        }
        nav ul {
          margin: 0;
          padding: 0;
          list-style-type: none;

          display: flex;
          align-items: center;

          li + li {
            margin-left: 16px;
          }
          li > a {
            padding: 8px;

            text-decoration: none;
            color: inherit;
          }
          li > a.active {
            text-decoration: underline;
          }
        }
        nav ul li a {
          font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
          font-size: 1rem;
          line-height: 1.5;
          font-weight: 400;
          letter-spacing: 0.00938em;
        }
      `}
    >
      <Link to={projectId ? `/projects/${projectId}` : '/'}>
        <div className="logo">
          <TailorLogo />
        </div>
      </Link>
      <nav>
        <ul>
          <li>
            <ProjectDropdown />
          </li>
          {projectId && (
            <Fragment>
              <li>
                <NavLink
                  to={`/projects/${projectId}/workflows`}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  Workflows
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`/projects/${projectId}/workflows/new`}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  New Workflow
                </NavLink>
              </li>
            </Fragment>
          )}
        </ul>
      </nav>
      <NavLink
        to="/dashboard"
        className={({ isActive }) => (isActive ? 'active' : '')}
        css={css`
          padding: 8px;
          margin-right: 16px;
          text-decoration: none;
          color: inherit;
          font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
          font-size: 1rem;
          line-height: 1.5;
          font-weight: 400;
          letter-spacing: 0.00938em;
          &.active {
            text-decoration: underline;
          }
        `}
      >
        Dashboard
      </NavLink>
      <NavLink
        to="/nodes"
        className={({ isActive }) => (isActive ? 'active' : '')}
        css={css`
          padding: 8px;
          margin-right: 16px;
          padding-right: 24px;
          border-right: 1px solid rgba(255, 255, 255, 0.3);
          text-decoration: none;
          color: inherit;
          font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
          font-size: 1rem;
          line-height: 1.5;
          font-weight: 400;
          letter-spacing: 0.00938em;
          &.active {
            text-decoration: underline;
          }
        `}
      >
        Nodes
      </NavLink>
      {loggedIn && <UserDropdown />}
      {loggedOut && (
        <Button variant="contained" onClick={() => signInWithRedirect()}>
          Log in
        </Button>
      )}
    </header>
  );
}
